import { NavLink } from "react-router-dom";

function About() {
    return <main className="about content-box">
        <div className="about-container">
            <div className="profile" />
            <div>
                <h1>Hi, ich bin Simon.</h1>
                <p className="subtitle">Filmer. Musiker. Informatiker.</p>
                <p>Ich liebe starke Bilder, gute Geschichten und saubere Umsetzung. Meine Arbeit bewegt sich genau dort: zwischen kreativem Gespür und technischer Klarheit. Ich entwickle Filme, die nicht zufällig entstehen, sondern bewusst gestaltet sind.</p>
                <p>Ich bin begeisterungsfähig – und möchte, dass dieser Funke auch auf den Zuschauer überspringt. Denn so wird deine Idee am Ende nicht nur gesehen, sondern auch gespürt.</p>
            </div>
            <div>
                <h2>Background</h2>
                <p>In meinem Informatikstudium habe ich mich auf Nutzer- und Kontextanalysen fokussiert, was meine Arbeitsweise bis heute prägt. Ich denke Projekte in Prozessen, arbeite mit strukturierten Methoden und nutze Kreativitätstechniken, um aus Ideen greifbare Konzepte zu machen.</p>
            </div>
            <div>
                <h2>Vision</h2>
                <p>Mich treibt die Liebe zur Kunst und die Begeisterung für Technik voran. Als aktiver Musiker bringe ich zusätzlich ein ausgeprägtes Gespür für Timing mit. Wenn Bild und Ton zusammenkommen, Kunst und Technologie sich ergänzen, dann entsteht für mich ein echtes Erlebnis.</p>
            </div>
        </div>
        <div className="cta">
            <span>Gespannt auf die Zusammenarbeit?</span>
            <NavLink className="button" to="/kontakt">Erzähl, was dich begeistert!</NavLink>
        </div>
    </main >
}

export default About;